/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccPatientOrganizationDetails
 */
export interface PccPatientOrganizationDetails {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    display: string;
    /**
     * 
     */
    phone?: string;
    /**
     * 
     */
    address?: string;
    /**
     * 
     */
    code?: string;
}

/**
 * Check if a given object implements the PccPatientOrganizationDetails interface.
 */
export function instanceOfPccPatientOrganizationDetails(value: object): value is PccPatientOrganizationDetails {
    if (!('display' in value) || value['display'] === undefined) return false;
    return true;
}

export function PccPatientOrganizationDetailsFromJSON(json: any): PccPatientOrganizationDetails {
    return PccPatientOrganizationDetailsFromJSONTyped(json, false);
}

export function PccPatientOrganizationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPatientOrganizationDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'display': json['display'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'address': json['address'] == null ? undefined : json['address'],
        'code': json['code'] == null ? undefined : json['code'],
    };
}

export function PccPatientOrganizationDetailsToJSON(json: any): PccPatientOrganizationDetails {
    return PccPatientOrganizationDetailsToJSONTyped(json, false);
}

export function PccPatientOrganizationDetailsToJSONTyped(value?: PccPatientOrganizationDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'display': value['display'],
        'phone': value['phone'],
        'address': value['address'],
        'code': value['code'],
    };
}

